import React, { useCallback } from 'react';
import { Box, costFormater, Inscription, List, RawButton } from '@common-fe/common-fe';

import { UnappliedFundsOrganization } from '../UnappliedFundsOrganizations.types';

interface Props {
  organization: UnappliedFundsOrganization;
  onManage: (orgId: number) => void;
}

const UnappliedFundsOrganizationItem: React.FC<Props> = ({ organization, onManage }) => {
  const { orgId, name, subsidiaryName, unappliedFunds, unpaidInvoicesAmount, unpaidInvoicesCount } =
    organization;
  const testIdPrefix = `unapplied-funds-organizations_item_${orgId}`;

  const handleManage = useCallback(() => onManage(orgId), [onManage, orgId]);

  return (
    <List.Item testId={testIdPrefix} height="68px" justify="center" pad={{ horizontal: 'spacing24' }}>
      <Box direction="row" align="center" fill>
        <Box style={{ flex: 4 }}>
          <RawButton onClick={handleManage} data-testid={`${testIdPrefix}_name-link`}>
            <Inscription weight="bold" color="textBody" data-testid={`${testIdPrefix}_name`}>
              {name}
            </Inscription>
          </RawButton>
          {subsidiaryName && (
            <Inscription
              size="small"
              weight={500}
              color="textSecondary"
              data-testid={`${testIdPrefix}_subsidiary-name`}
            >
              {subsidiaryName}
            </Inscription>
          )}
        </Box>

        <List.Item.Text flex={2} testId={`${testIdPrefix}_unapplied-funds`} weight="normal">
          {costFormater(unappliedFunds, true)}
        </List.Item.Text>

        <List.Item.Text flex={2} testId={`${testIdPrefix}_unpaid-invoices`} weight="normal">
          {`${costFormater(unpaidInvoicesAmount, { isOptionalPrecision: true })} (${unpaidInvoicesCount})`}
        </List.Item.Text>

        <Box width="24px" align="center" justify="center" margin={{ left: 'spacing24' }}>
          <List.Item.Options testId={`${testIdPrefix}_options`}>
            <List.Item.Options.Item testId={`${testIdPrefix}_manage-action`} onClick={handleManage}>
              Manage
            </List.Item.Options.Item>
          </List.Item.Options>
        </Box>
      </Box>
    </List.Item>
  );
};

export default UnappliedFundsOrganizationItem;
